export const SERVICES_ORIGINAL_BREADCRUMBS = { name: "Services", url: "services" };
export const BLOGS_ORIGINAL_BREADCRUMBS = { name: "Blog", url: "blog" };
